import type { MailboxInfo } from "owa-client-types";
import { isAccountFeatureEnabled } from "owa-feature-flags";
import type { SearchScope } from "owa-search-service/lib/data/schema/SearchScope";
import { SearchProvider } from "owa-search-service/lib/data/schema/SearchProvider";
import type ReactListViewType from "owa-service/lib/contract/ReactListViewType";
import getSearchProvider from "../selectors/getSearchProvider";
import getSearchScopeListViewType from "./getSearchScopeListViewType";

export default function isGenWebQueryOnTypeEligible(searchScope: SearchScope | undefined, mailboxInfo: MailboxInfo): boolean {
    const isQueryOnTypeEnabled = isAccountFeatureEnabled("sea-gwc-query-on-type-entity", mailboxInfo) ||
        isAccountFeatureEnabled("sea-gwc-query-on-type", mailboxInfo) ||
        isAccountFeatureEnabled("sea-gwc-query-on-type-with-7-results", mailboxInfo);
    
    if (!searchScope || !self.navigator.onLine || !isQueryOnTypeEnabled) {
        return false;
    }
    
    const searchProvider = getSearchProvider(searchScope);
    return ((searchProvider === SearchProvider.Substrate ||
        searchProvider === SearchProvider.SubstrateV2) &&
        getSearchScopeListViewType(searchScope, mailboxInfo) === 1);
}
